import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-3xl my-12 text-center" }, " Learn faster with our pro plan! ", -1)
const _hoisted_2 = { class: "lg:mx-auto" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row mx-8 space-y-8 lg:space-y-0 lg:space-x-8 justify-center" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode()
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mx-8 lg:w-2/3 lg:mx-auto mb-12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-2xl pt-8 my-12 text-center" }, " What is \"Single Click Mode\"? "),
  /*#__PURE__*/_createElementVNode("p", null, " Instead of clicking \"translate\" button, then \"create audio\" and then \"search images\", you can get translations, audio and images with just one button click! "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-2xl pt-8 my-12 text-center" }, " What is \"create audio\" feature? "),
  /*#__PURE__*/_createElementVNode("p", null, " Listen to correct pronounciation of words when practicing. The app use \"text-to-speech\" technology to create natural sounding audio. This feature is not available for some languages. You can see full language support list here: TODO "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-center text-2xl pt-8 my-12 text-center" }, " Tell me more about \"images per search\" "),
  /*#__PURE__*/_createElementVNode("p", null, " More image search results in the pro version will help you find the perfect picture related to the word you are learning! ")
], -1)

import { PricingTier } from "@/PricingTier";
import PricingPageTier from "./PricingPageTier.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const freeTier = new PricingTier();
freeTier.name = "free";
freeTier.price = 0;
freeTier.canAddAudio = false;
freeTier.imageSearchResults = 3;
freeTier.singleClickMode = false;
freeTier.translationDailyLimit = 20;

const proTier = new PricingTier();
proTier.name = "pro";
proTier.price = 3;
proTier.canAddAudio = true;
proTier.imageSearchResults = 9;
proTier.singleClickMode = true;
proTier.translationDailyLimit = 100;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PricingPageTier, { tier: _unref(freeTier) }, null, 8, ["tier"]),
        _hoisted_4,
        _createVNode(PricingPageTier, { tier: _unref(proTier) }, null, 8, ["tier"])
      ])
    ]),
    _hoisted_5
  ], 64))
}
}

})